// WARNING: These constants are consumed by product.js (STOCK_GROUPS, TIERS, LOCATION_MAP).
// Any change to warehouse keys, groups or locations must be verified against that file's logic.

const TIERS = [
    {
        key: "local",
        location: "LOCAL WAREHOUSE",
        cls: "singapore",
        msg: "in_stock",
        wh: "LocalStock",
        stockGroup: "inStock",
    },
    {
        key: "localBlue",
        location: "LOCAL BLUE",
        cls: "local-blue",
        msg: "incoming",
        wh: "LocalBlueStock",
        stockGroup: "inTransit",
    },
    {
        key: "localRed",
        location: "LOCAL RED",
        cls: "local-red",
        msg: "incoming",
        wh: "LocalRedStock",
        stockGroup: "inTransit",
    },
    {
        key: "globalWh",
        location: "GLOBAL",
        cls: "global",
        msg: "pre_order",
        wh: "GlobalStock",
        stockGroup: "preOrder",
    },
    {
        key: "globalBlue",
        location: "GLOBAL BLUE",
        cls: "global-blue",
        msg: "pre_order",
        wh: "GlobalBlueStock",
        stockGroup: "preOrder",
    },
    {
        key: "globalRed",
        location: "GLOBAL RED",
        cls: "global-red",
        msg: "pre_order",
        wh: "GlobalRedStock",
        stockGroup: "preOrder",
    },
    {
        key: "globalGrey",
        location: "GLOBAL GREY",
        cls: "global-grey",
        msg: "pre_order",
        wh: "GlobalGreyStock",
        stockGroup: "preOrder",
    },
]

const STOCK_GROUPS = TIERS.reduce((groups, tier) => {
    if (!groups[tier.stockGroup]) groups[tier.stockGroup] = [];
    groups[tier.stockGroup].push(tier);
    return groups;
}, {});

const LOCATION_MAP = TIERS.reduce((map, tier) => {
    map[tier.location.toUpperCase()] = tier.key;
    return map;
}, {});
